import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CommentEmptyCloud = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.16927 12.6666H5.83594C3.16927 12.6666 1.83594 12 1.83594 8.66665V5.33331C1.83594 2.66665 3.16927 1.33331 5.83594 1.33331H11.1693C13.8359 1.33331 15.1693 2.66665 15.1693 5.33331V8.66665C15.1693 11.3333 13.8359 12.6666 11.1693 12.6666H10.8359C10.6293 12.6666 10.4293 12.7666 10.3026 12.9333L9.3026 14.2666C8.8626 14.8533 8.1426 14.8533 7.7026 14.2666L6.7026 12.9333C6.59594 12.7866 6.34927 12.6666 6.16927 12.6666Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1656 7.33333H11.1716"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49373 7.33333H8.49972"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.82967 7.33333H5.83566"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CommentEmptyCloud.displayName = 'CommentEmptyCloud';
